module.exports = __webpack_public_path__ + "img/kakao.e767e643.png";